"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarChartContainer = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BarChartContainer = exports.BarChartContainer = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1omf8wg0"
} : {
  target: "e1omf8wg0",
  label: "BarChartContainer"
})("height:", props => props.height && props.height, ";width:", props => props.width && props.width, ";");